import React from 'react'
import {ReactComponent as Mono} from './images/mono.svg'
import {ReactComponent as Standard} from './images/standard.svg'
import './styles.scss'

export default function Logo({className, mono}) {
  const SvgIcon = mono ? Mono : Standard
  return <SvgIcon className={`Logo ${className}`} />
}
